// removed by extract-text-webpack-plugin
module.exports = {"icon":"_42xn5gxjzsekq232tq6wy1rn6sqnpf2fy5ufdkgtuy6n5e842e77tasd448t7eakbb78p9cu4wd3x3fpt2wn786r2f68b49ctu62d52-Icon-module-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Icon/Icon.module.sass
// module id = 491
// module chunks = 0